import React from "react";
import axios from "axios";
import Consts from "../../helpers/Consts";

class JwPlayer873 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tumbnailUrl: "",
      thumbnailFinishedLoading: false,
    };

    this.videoTitle = this.props.item["artifact.ingress.title"];
    this.videoProducer = this.props.item["artifact.ingress.producer"];
    this.id = this.props.item["identifier.id"];
    this.videoPlayer;
    this.videoInformation;
    this.videoPlayerId = "jw-player-873";
    this.jwPlayerOptions = {
      width: "100%",
      aspectratio: "16:9",
      file: "",
    };

    // Bind 'this' for event handlers
    this.initializeVideoPlayerAndStartVideo = this.initializeVideoPlayerAndStartVideo.bind(
      this
    );
    this.thumbnailLoadingError = this.thumbnailLoadingError.bind(this);
    this.thumbnailLoaded = this.thumbnailLoaded.bind(this);
  }

  fetchVideoFromApi() {
    if (!this.id) return;

    let url = `${Consts.api.baseUrl}api/artifact?owner=STO&identifier=${this.id}&mapping=simple_json&api.key=${Consts.api.key}`;

    axios.get(url).then(this.initializeComponent.bind(this));
  }

  initializeComponent(response) {
    let hasTumbnail = response.data.images.length > 0;

    if (hasTumbnail)
      this.setState({ tumbnailUrl: response.data.images[0].url });

    let videoObjects = $.grep(response.data.files, (file) => {
      return file.fileType === "Video";
    });

    if (videoObjects.length === 0) return;

    // Just take the first video, should be the correct one.
    this.videoInformation = videoObjects[0];

    if (!hasTumbnail) this.initializeVideoPlayer();
  }

  componentDidMount() {
    this.fetchVideoFromApi();
  }

  componentWillUnmount() {
    if (!this.videoPlayer) return;

    this.videoPlayer.remove();
  }

  initializeVideoPlayer() {
    // Should not happen, but just return if we
    // don't have the video object or playlist URL.
    if (!this.videoInformation || !this.videoInformation.playlistUrl) return;

    this.jwPlayerOptions.file = this.videoInformation.playlistUrl;

    // This won't run if not in context of the actual web site
    // where jwplayer is loaded.
    this.videoPlayer = jwplayer(this.videoPlayerId);

    this.videoPlayer.setup(this.jwPlayerOptions);
  }

  playVideo() {
    if (!this.videoPlayer) return;

    this.videoPlayer.play();
  }

  thumbnailLoaded() {
    this.setState({ thumbnailFinishedLoading: true });
  }

  thumbnailLoadingError() {
    this.initializeVideoPlayer();
  }

  initializeVideoPlayerAndStartVideo() {
    this.initializeVideoPlayer();
    this.playVideo();
  }

  render() {
    let tumbnailAltText = `${this.props.titleText}: ${this.videoTitle}. ${this.props.artistText}: ${this.videoProducer}.`;

    return (
      <div id={this.videoPlayerId}>
        {this.state.tumbnailUrl ? (
          <div class="gallery-video-tumbnail-and-play-button-wrapper">
            {this.state.thumbnailFinishedLoading ? (
              <div class="gallery-video-overlay">
                <button
                  type="button"
                  aria-label={this.props.ariaLabelVideoPlayButtonText}
                  class="gallery-video-play-button"
                  onClick={this.initializeVideoPlayerAndStartVideo}
                ></button>
              </div>
            ) : null}
            <img
              className="gallery-video-tumbnail-image"
              src={this.state.tumbnailUrl}
              alt={tumbnailAltText}
              onError={this.thumbnailLoadingError}
              onLoad={this.thumbnailLoaded}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default JwPlayer873;
